export default [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Site Genel',
    route: null,
    icon: 'GlobeIcon',
    children: [
      {
        title: 'Site Menü',
        route: 'SiteMenus',
        resource: 'ADMIN_SITE_MENU',
        action: 'read',
      },
      {
        title: 'Carousel',
        route: 'Carousel',
        resource: 'ADMIN_CAROUSEL',
        action: 'read',
      },
      {
        title: 'Sabit İçerikler',
        route: 'Contents',
        resource: 'ADMIN_CONTENTS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kurumsal',
    route: null,
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Tarihçe & Hakkımızda',
        route: 'About',
        resource: 'ADMIN_ABOUT',
        action: 'read',
      },
      {
        title: 'İletişim',
        route: 'Contacts',
        resource: 'ADMIN_CONTACT',
        action: 'read',
      },
      {
        title: 'Markalar',
        route: 'Brands',
        resource: 'ADMIN_BRANDS',
        action: 'read',
      },
      {
        title: 'Referanslar',
        route: 'References',
        resource: 'ADMIN_REFERENCES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Blog',
    route: 'Blog',
    icon: 'BookIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'BlogAdd',
        resource: 'ADMIN_BLOG',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Blog',
        resource: 'ADMIN_BLOG',
        action: 'read',
      },
      {
        title: 'Kategoriler',
        route: 'BlogCategories',
        resource: 'ADMIN_BLOG_CATEGORIES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ürünler',
    route: 'Products',
    icon: 'LayersIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'ProductAdd',
        resource: 'ADMIN_PRODUCTS_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Products',
        resource: 'ADMIN_PRODUCTS',
        action: 'read',
      },
      {
        title: 'Kategoriler',
        route: 'ProductCategories',
        resource: 'ADMIN_PRODUCT_CATEGORIES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Modüller',
    route: null,
    icon: 'CodesandboxIcon',
    children: [
      {
        title: 'Lead Form',
        route: 'ModLeads',
        resource: 'ADMIN_MODULES',
        action: 'read',
      },
      {
        title: 'Sosyal Medya',
        route: 'Socialmedia',
        resource: 'ADMIN_MODULES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kullanıcılar',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ayarlar',
    route: null,
    icon: 'SettingsIcon',
    children: [
      {
        title: 'SMTP Ayarları',
        route: 'Smtp',
        resource: 'ADMIN_SMTP',
        action: 'read',
      },
    ],
  },
]
